var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "analytics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.09,21.41H2.6a1.35,1.35,0,0,1-.92-.92V1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.53 18.38 9.25 10.51 12.4 12.87 14.76 8.15 18.69 9.72 22.1 5.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.87 9.5 22.12 9.54 21.92 5.85 18.25 6.32 18.16 5.57 22.63 5 22.87 9.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics01);
export default __webpack_public_path__ + "static/media/analytics_01.4c7f8a1faeb76139c58c325bd05bcc33.svg";
export { ForwardRef as ReactComponent };